import useApi from "../../use/useApi";
import {useSelector} from "react-redux";
import isNull from "../../mixin/isNull";
import DefaultItem from "../../entity/emergency/DefaultItem";

const SERVICE = "service-emergency";
const ENTITY = "default_items";

export default function () {
    const {findAll} = useApi();
    const state = useSelector;
    const newInstance = data => new DefaultItem(data);

    return {
        findAll() {
            return {
                select() {
                    const result = state(state => state.api?.emergency?.[ENTITY]?.filter(d => !isNull(d)));

                    if (isNull(result)) return null;

                    return result;
                },
                exec() {
                    findAll(SERVICE, ENTITY, newInstance, "application_v7");
                }
            }
        }
    }
}